<form class="text-start">
  @for (item of controlsData; track item; let i = $index; let last = $last) {
    <div
      class="row"
      >
      <div class="col-sm-12">
        @if (item.label && isQuePage) {
          <p
            class="col-sm-12 question-label d-flex flex-wrap align-items-start"
            >
            <span class="question-number me-2">{{ i + 1 }}.</span>
            <span
              class="question-text dynamic-content title summary-heading"
              [innerHtml]="item.label"
            ></span>
          </p>
        }
        @if (item.label && !isQuePage) {
          <p class="col-sm-12" >
            <span class="col-form-label title summary-heading" [innerHtml]="item.label"></span>
          </p>
        }
      </div>
      <div class="col-sm-12" [ngClass]="customClass">
        @if (item.type === 'select') {
          <p>
            @for (option of item.options; track option) {
              <span>
                @if (option.value == item.value) {
                  <span class="font-normal">
                    {{ option.key }}
                  </span>
                }
              </span>
            }
          </p>
        }
        @if (item.type !== 'select' && item.type !== 'hidden' && item.type !== 'date') {
          <p class="font-normal">
            {{item.value}}
          </p>
        }
        @if (item.type === 'date') {
          <p class="font-normal">
            {{item.value | date: 'MM/dd/yyyy'}}
          </p>
        }
        @if (item.type !== 'hidden') {
          <hr/>
        }
      </div>
    </div>
  }
</form>
